import React from 'react';
import PropTypes from 'prop-types';
import {withStore, withScreenCheck} from '../hoc';
import Navbar from '../components/Navbar';
import Header from '../components/Header';
import Body from '../components/Body';
import Footer from '../components/Footer';
import {CardChronique as Chronique} from '../components/Cards';
import ChevronDown from '../svg/ICON_chevronDown_Dark.svg';

/**
 * ChroniquePage
 */
class ChroniquePage extends React.Component {
  static displayName = 'Chronique';
  static propTypes = {
    stores: PropTypes.object.isRequired,
    currentPage: PropTypes.object.isRequired,
    screen: PropTypes.string.isRequired,
  };

  static defaultProps = {};

  /**
   * @constructor
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.chronPas = 3;
    this.state = {
      chronNum: 3,
    };
    this.loadMore = this.loadMore.bind(this);
  }

  /**
   * Load more chroniques
   */
  loadMore() {
    this.setState({
      chronNum: this.state.chronNum + this.chronPas,
    });
  }

  /**
   * @override
   */
  render() {
    const chroniques = this.props.currentPage.chroniques();
    return (
      <div className="Chronique">
        <Navbar {...this.props} />
        <Header
          {...this.props}
          images={[
            this.props.screen === 'desktop'
              ? this.props.currentPage.heroImage()
              : this.props.currentPage.heroMobileImage(),
          ]}
        >
          {this.props.currentPage.heroCaption()}
        </Header>
        <Body {...this.props}>
          {chroniques
            .slice(0, this.state.chronNum)
            .map(chronique => (
              <Chronique
                key={chronique.ID}
                chronique={chronique}
                {...this.props}
              />
            ))}
          {chroniques.size > this.state.chronNum &&
            <div className={`CardChronique__more`}>
              <button onClick={this.loadMore}>
                Plus de chroniques
                <img src={ChevronDown} alt="down" />
              </button>
            </div>}
        </Body>
        <Footer {...this.props} />
      </div>
    );
  }
}
export default withStore(withScreenCheck(ChroniquePage));



// WEBPACK FOOTER //
// ./src/pages/ChroniquePage.js